/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentsTransfer } from "../funcs/agentsTransfer.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ManagedAgent } from "../models/components/managedagent.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  TransferAgentRequest,
  TransferAgentSecurity,
} from "../models/operations/transferagent.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type TransferAgentMutationVariables = {
  request: TransferAgentRequest;
  security?: TransferAgentSecurity | undefined;
  options?: RequestOptions;
};

export type TransferAgentMutationData = ManagedAgent;

export type TransferAgentMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * transfer agents
 */
export function useTransferAgentMutation(
  options?: MutationHookOptions<
    TransferAgentMutationData,
    TransferAgentMutationError,
    TransferAgentMutationVariables
  >,
): UseMutationResult<
  TransferAgentMutationData,
  TransferAgentMutationError,
  TransferAgentMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildTransferAgentMutation(client, options),
    ...options,
  });
}

export function mutationKeyTransferAgent(): MutationKey {
  return ["@gram/client", "agents", "transfer"];
}

export function buildTransferAgentMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: TransferAgentMutationVariables,
  ) => Promise<TransferAgentMutationData>;
} {
  return {
    mutationKey: mutationKeyTransferAgent(),
    mutationFn: function transferAgentMutationFn({
      request,
      security,
      options,
    }): Promise<TransferAgentMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(agentsTransfer(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
